import http from '../../plugins/axios';

export default {

    getAgreements(data) {
        return http.get({
            url : '/admin/agreement/allInfos',
            data
        })
    },

    getAgreementById(data) {
        return http.get({
            url : '/admin/agreement/infoById',
            data
        })
    },

    alterAgreement(data) {
        return http.post({
            url : '/admin/agreement/alter',
            data,
            dataType : 'form'
        })
    },

    insertAgreement(data) {
        return http.post({
            url : '/admin/agreement/add',
            data,
            dataType : 'form'
        })
    },

    deleteAgreement(data) {
        return http.post({
            url : '/admin/agreement/delete',
            data,
            dataType : 'form'
        })
    }
}